import { c as _c } from "react/compiler-runtime";
import { ScrollArea as ScrollAreaPrimitive } from "@base-ui/react/scroll-area";
import { cn } from "../utils";
function ScrollArea(t0) {
  const $ = _c(29);
  let children;
  let className;
  let contentRef;
  let props;
  let scrollRef;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      children,
      scrollFade: t1,
      scrollbarGutter: t2,
      hideScrollbar: t3,
      scrollRef,
      contentRef,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = contentRef;
    $[4] = props;
    $[5] = scrollRef;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    children = $[1];
    className = $[2];
    contentRef = $[3];
    props = $[4];
    scrollRef = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  const scrollFade = t1 === undefined ? true : t1;
  const scrollbarGutter = t2 === undefined ? false : t2;
  const hideScrollbar = t3 === undefined ? false : t3;
  let t4;
  if ($[9] !== className) {
    t4 = cn("relative flex min-h-0 min-w-0 overflow-hidden", className);
    $[9] = className;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = scrollFade && "mask-t-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-y-start)))] mask-r-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-x-end)))] mask-b-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-y-end)))] mask-l-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-x-start)))] [--fade-size:1.5rem]";
  const t6 = scrollbarGutter && "data-has-overflow-x:pb-2.5 data-has-overflow-y:pr-2.5";
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = cn("no-scrollbar flex-1 rounded-[inherit] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 data-has-overflow-x:overscroll-x-contain", t5, t6);
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children || $[15] !== contentRef) {
    t8 = <ScrollAreaPrimitive.Content data-slot="scroll-area-content" ref={contentRef}>{children}</ScrollAreaPrimitive.Content>;
    $[14] = children;
    $[15] = contentRef;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== scrollRef || $[18] !== t7 || $[19] !== t8) {
    t9 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" ref={scrollRef} className={t7}>{t8}</ScrollAreaPrimitive.Viewport>;
    $[17] = scrollRef;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== hideScrollbar) {
    t10 = !hideScrollbar && <><ScrollBar orientation="vertical" /><ScrollBar orientation="horizontal" /></>;
    $[21] = hideScrollbar;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ScrollAreaPrimitive.Corner data-slot="scroll-area-corner" />;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== props || $[25] !== t10 || $[26] !== t4 || $[27] !== t9) {
    t12 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t4} {...props}>{t9}{t10}{t11}</ScrollAreaPrimitive.Root>;
    $[24] = props;
    $[25] = t10;
    $[26] = t4;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function ScrollBar(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("m-1 flex opacity-0 transition-opacity delay-300 data-hovering:opacity-100 data-hovering:delay-0 data-hovering:duration-100 data-scrolling:opacity-100 data-scrolling:delay-0 data-scrolling:duration-100 data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:flex-col data-[orientation=vertical]:w-1", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollAreaPrimitive.Thumb data-slot="scroll-area-thumb" className="relative flex-1 rounded-full bg-black/40 dark:bg-white/40" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== orientation || $[8] !== props || $[9] !== t2) {
    t4 = <ScrollAreaPrimitive.Scrollbar data-slot="scroll-area-scrollbar" orientation={orientation} className={t2} {...props}>{t3}</ScrollAreaPrimitive.Scrollbar>;
    $[7] = orientation;
    $[8] = props;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export { ScrollArea, ScrollBar };